var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('div',{attrs:{"id":"app"}},[_c('navigation'),_c('router-view',{key:_vm.$route.fullPath})],1):_c('div',{staticClass:"loader"},[_c('fulfilling-square-spinner',{attrs:{"animation-duration":1000,"size":40,"color":'#5a754d'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }